import { initI18n } from '@bluecodecom/i18n';

initI18n({ en: {}, de: {}, it: {} }, undefined, true);
